// extracted by mini-css-extract-plugin
export default {"Container":"BonusMotivator_Container__RbWQq","Text":"BonusMotivator_Text__DNxac"};